import React from 'react';

const Footer = () => {
		return(
		<footer>

            <h6>prodigygod0209@gmail.com</h6>
            <ul>
              <li><a href="https://www.linkedin.com/in/士凱-洪-a17277a6/">Linkedin</a></li>
              <li><a href="https://github.com/prodigygod0209">Github</a></li>
              <li><a href="https://www.instagram.com/hongkai1991/">Instagram</a></li>
              <li><a href="https://www.facebook.com/profile.php?id=100001045283332">Facebook</a></li>
              <li><a href="https://medium.com/@kaihong">Medium</a></li>
            </ul>
             <p>© 2017 Shi-Kai Hong </p>
        </footer>
	   )
	
}



export default Footer


// WEBPACK FOOTER //
// ./src/components/footer.js